import React, { memo } from "react";
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalBody,
   Flex,
   Text,
   Image,
   ModalCloseButton,
   Button,
} from "@chakra-ui/react";
export default memo(function VipWarningModal({ isOpen, onClose }) {
   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         blockScrollOnMount={false}
         isCentered
         size={{ base: "xs", BREAK_PAD: "md", BREAK_LPC: "lg" }}>
         <ModalOverlay />
         <ModalContent>
         <ModalCloseButton _focus={{ boxShadow: "none" }} color={"#999"} />

            <ModalBody px={{ base: '20px', BREAK_LPC: '30px' }} pt={"30px"} pb={{ base: '20px', BREAK_LPC: '40px' }}>
               <Flex flexDir="column" w={"full"} alignItems="center">
                  <Image
                     alt="logo"
                     userSelect={"none"}
                     src={process.env.REACT_APP_PUBLIC_URL + "iconfont/logo_icon.svg"}
                     w={{ base: "136px", BREAK_LPC: "184px" }}
                     h={{ base: "36px", BREAK_LPC: "48px" }}
                  />
                  <Text mt={{ base: '12px', BREAK_LPC: '20px' }} fontSize={{ base: 18, BREAK_LPC:20 }} variant={'bold'} color="#333" textAlign={"center"}>
                     You are already a VIP user !
                  </Text>
                  <Button
                     fontSize={14}
                     color="white"
                     h={"50px"}
                     w={"207px"}
                     mt={"30px"}
                     onClick={onClose}
                     alignSelf="center"
                     colorScheme={"green"}
                     borderRadius={"25px"}>
                     OK
                  </Button>
               </Flex>
            </ModalBody>
         </ModalContent>
      </Modal>
   );
});
